import { render, staticRenderFns } from "./OverlayCornerRound.vue?vue&type=template&id=2e6db7d2"
import script from "./OverlayCornerRound.vue?vue&type=script&lang=js"
export * from "./OverlayCornerRound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports